import { SavedView } from "../SavedViewsMenu.types.ts";
import { FilterPage } from "../../../pageView/PageView.types.ts";
import { useSetSavedViewAsGlobalDialog } from "./SetSavedViewAsGlobalDialog.hooks.ts";
import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation.ts";

export interface SetSavedViewAsGlobalDialogProps {
    view: SavedView;
    savedViewType: FilterPage;
    onClose: () => void;
    onSuccess: () => void;
}

function SetSavedViewAsGlobalDialog(props: SetSavedViewAsGlobalDialogProps) {
    const { translateString } = useTranslation();
    const { handleViewAsGlobal, inProgress } = useSetSavedViewAsGlobalDialog(props);
    return (
        <DotLegalInfoDialog
            onCloseDialog={props.onClose}
            header={translateString("saveAsGlobalView")}
            btnText={translateString("save")}
            onBtnClick={handleViewAsGlobal}
            inProgress={inProgress}
            content={translateString("saveViewAsGlobalToolTipText")}
        />
    );
}

export default SetSavedViewAsGlobalDialog;
